export default __webpack_public_path__ + "static/media/EnergySaving.921c06cb.svg";